import { paths } from '@/routes/paths';
import { PERMISSIONS } from '@/types/roles';

/**
 * The three pages that sit behind "Company profile" in the sidebar. Each keeps
 * its own URL, so links already sent in notifications and emails still land.
 * A tab with a `permission` shows only to members who hold it; "My account"
 * has none because every member has an account.
 */
export const PROFILE_TABS = [
  {
    to: paths.company.profile,
    label: 'Profile',
    icon: 'building',
    permission: PERMISSIONS.COMPANY_PROFILE_UPDATE,
  },
  {
    to: paths.company.branding,
    label: 'Employer brand',
    icon: 'star',
    permission: PERMISSIONS.COMPANY_BRANDING_UPDATE,
  },
  { to: paths.company.access, label: 'My account', icon: 'userCheck' },
];

export function visibleProfileTabs(can) {
  return PROFILE_TABS.filter((tab) => !tab.permission || can(tab.permission));
}
